export const config = {
  backofficeApiUrl: import.meta.env.VITE_BACKOFFICE_API_URL || 'http://localhost:8080',
  /**
   * The Backoffice ADMIN frontend — project-management links for GTI staff
   * (`{origin}/admin/project/{id}`). Distinct from `backofficeAppUrl`,
   * the client/partner-facing legacy platform. Deliberately no
   * API-URL fallback: a misconfig should point at localhost, not the API.
   */
  backofficeAdminUrl: import.meta.env.VITE_BACKOFFICE_ADMIN_URL || 'http://localhost:4201',
  /**
   * The legacy Backoffice platform clients and partners log into — the
   * /bounce redirect target and the clients' "Historic Reports" link.
   */
  backofficeAppUrl: import.meta.env.VITE_BACKOFFICE_APP_URL || 'https://platform.gtintel.io',
  vnextApiUrl: import.meta.env.VITE_VNEXT_API_URL || 'http://127.0.0.1:8080',
  environment: import.meta.env.VITE_ENVIRONMENT || 'dev',
  /**
   * Guided-demo build: the app runs fully offline against canned data
   * (src/demo). Build-time flag — seams that must tree-shake out of
   * production bundles gate on the literal `import.meta.env.VITE_DEMO_MODE`
   * instead of this runtime value.
   */
  demoMode: import.meta.env.VITE_DEMO_MODE === 'true',
  /**
   * The client monitoring pages (`/monitoring`). Hidden unless exactly
   * `'true'`, so an environment shows clients nothing about monitoring until
   * someone decides it should. Read at build time: changing it needs a
   * rebuild, which on Railway saving the variable triggers.
   */
  clientMonitoringEnabled: import.meta.env.VITE_CLIENT_MONITORING_ENABLED === 'true',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;

export type Environment = 'dev' | 'stg' | 'prd';
